/**
 * True when the certifications section counts as "complete" for progress / section UI:
 * explicit NA or at least one certification entry.
 */
export function isCertificationsSectionComplete(data) {
  if (!data) return false;
  const { noCertifications, certifications } = data;
  return noCertifications === true || (certifications?.length || 0) > 0;
}

/**
 * True when the certifications array has no entries.
 */
export function isCertificationsFormEmpty({ certifications }) {
  return !Array.isArray(certifications) || certifications.length === 0;
}
